/**
 * Тексты постоянного уведомления о финальном провале загрузки переводов.
 *
 * Осознанно захардкожены: в момент показа уведомления переводы недоступны,
 * поэтому идти за текстом в TranslateService нельзя — иначе покажем сырой ключ.
 */
export const TRANSLATION_FAILURE_MESSAGES = {
  ru: 'Не удалось загрузить переводы. Возможно, нестабильное интернет-соединение - перезагрузите страницу.',
  en: 'Failed to load translations. Your connection may be unstable - please reload the page.',
} as const;

/**
 * Выбрать текст уведомления по языку приложения / браузера.
 *
 * Порядок: initialLang → navigator.language → null (текст не выбран, показывать оба варианта).
 * Маппинг: base-язык 'ru' (включая 'ru-RU', 'ru_UA' и т.п.) → RU, всё остальное → EN.
 * Без неявных догадок по региону — только явный код языка.
 *
 * @param initialLang язык, выбранный приложением при старте (может быть пустым)
 * @param navigatorLang язык браузера (может быть пустым)
 * @returns текст уведомления или null, если язык определить не удалось
 */
export function resolveTranslationFailureMessage(
  initialLang: string | null | undefined,
  navigatorLang: string | null | undefined,
): string | null {
  const candidates: Array<string | null | undefined> = [initialLang, navigatorLang];

  for (const candidate of candidates) {
    const normalized = candidate?.trim().toLowerCase();
    if (!normalized) {
      continue;
    }
    // Сравниваем по base-языку: 'ru-RU' и 'ru' оба дают русский текст
    const baseLang = normalized.replace(/_/g, '-').split('-')[0];
    return baseLang === 'ru' ? TRANSLATION_FAILURE_MESSAGES.ru : TRANSLATION_FAILURE_MESSAGES.en;
  }

  return null;
}
